let loaderPromise = null;

// Loads the Square Web Payments SDK once, matching the configured environment.
export function loadSquare() {
  if (loaderPromise) return loaderPromise;
  if (window.Square) return Promise.resolve(window.Square);
  const env = process.env.REACT_APP_SQUARE_ENV || "sandbox";
  const src =
    env === "production"
      ? "https://web.squarecdn.com/v1/square.js"
      : "https://sandbox.web.squarecdn.com/v1/square.js";

  loaderPromise = new Promise((resolve, reject) => {
    const s = document.createElement("script");
    s.src = src;
    s.async = true;
    s.onload = () => resolve(window.Square);
    s.onerror = () => reject(new Error("Square SDK failed to load"));
    document.head.appendChild(s);
  });
  return loaderPromise;
}

export const squareEnabled = () => Boolean(process.env.REACT_APP_SQUARE_APP_ID);
